export { default as VodapayProvider } from './vodapay-provider';
